import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  ChevronDownIcon,
  Cog6ToothIcon,
  DocumentTextIcon,
  EyeDropperIcon,
  UserIcon,
  UsersIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
} from '@headlessui/react';
import Logo from '../../assets/svg/logo.svg';
import { Bars3Icon } from '@heroicons/react/24/solid';
import { ROLES } from '../../core/constants';
import { setBaseURL } from '../../services/axiosConfig';
import VersionComponent from '../../components/VersionComponent';
import { isEmpty } from 'lodash';
import { useSystemEnv } from './SystemEnvContext';
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarLeftExpand,
} from 'react-icons/tb';
import useSidebarCollapsed from '../../hooks/useSidebarCollapsed';

const TicketIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
      />
    </svg>
  );
};

const ChartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
      />
    </svg>
  );
};

const ErrorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
      />
    </svg>
  );
};

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function AdminLayout({ children }, ...props) {
  const userNavigation = [
    // { name: "Your profile", href: "#" },
    { name: '로그아웃', id: 'logout' },
  ];

  const dbConfig = localStorage.getItem('X-DB-KEY');
  const isUrinalysis = () => dbConfig && !isEmpty(dbConfig) && dbConfig === 'urinalysis';

  const initialNavigation = [
    { name: '관리', href: '', icon: null },
    { name: '관리자 관리', href: '/ad/admin', icon: UserIcon },
    { name: '회원 관리', href: '/ad/user', icon: UsersIcon },
    { name: '회원권 관리', href: '/ad/coupon2', icon: TicketIcon },
    { name: '회원권 관리2', href: '/ad/coupon', icon: TicketIcon },
    { name: '조직도 관리', href: '/ad/treeViewDetail', icon: UserIcon },
    { name: '시스템 설정', href: '', icon: null },
    { name: '시뮬레이션', href: '/ad/simulation', icon: ChartIcon },
    { name: '환경설정', href: '/ad/envvariables', icon: Cog6ToothIcon },
    { name: '소변분석 관리', href: '/ad/uri/mnt', icon: EyeDropperIcon },
    { name: '공지사항', href: '/ad/notice', icon: DocumentTextIcon },
    { name: '이슈게시판', href: '/ad/issue', icon: ErrorIcon },
  ];

  console.log(isUrinalysis()?'소변':'활성');
  console.log(initialNavigation);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  // 데스크톱 사이드바 접기(모바일 드로어인 sidebarOpen 과는 별개)
  const [sidebarCollapsed, setSidebarCollapsed] = useSidebarCollapsed();
  const [navigation, setNavigation] = useState(initialNavigation);
  const [hideServerSelection, setHideServerSelection] = useState(false);
  const { auth, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { env } = useSystemEnv();


  useEffect(() => {
    if (auth) {
      // console.log("🚀 ~ useEffect ~ auth:", auth);
      if (!isUrinalysis()) {
        if (auth.admin_level_cd === ROLES.Volunteer) {
          setHideServerSelection(true);
          const filteredNavs = navigation.filter((item) => {
            if (
              item.name !== '시뮬레이션' &&
              item.name !== '환경설정' &&
              item.name !== '공지사항' &&
              item.name !== '소변분석 관리' 
              // && item.name !== '조직도 관리'
            ) {
              return item;
            }
          });
          console.log("🚀 ~ filteredNavs ~ 활성 본사 filteredNavs:", filteredNavs);
          setNavigation(filteredNavs);
        } else {
          // setHideServerSelection(false);
          const filteredNavs = navigation.filter((item) => {
            if (item.name !== '소변분석 관리' 
              //&&  item.name !== '조직도 관리'
            ) {
              return item;
            }
          });
          console.log("🚀 ~ filteredNavs ~ 활성 관리자 filteredNavs:", filteredNavs);
          setNavigation(filteredNavs);
        }
      }
      else {
        if (auth.admin_level_cd === ROLES.Volunteer) {
          setHideServerSelection(true);
          const filteredNavs = navigation.filter((item) => {
            if (
              item.name !== '시뮬레이션' &&
              item.name !== '환경설정' &&
              item.name !== '공지사항' &&
              item.name !== '회원권 관리' &&
              item.name !== '회원권 관리2'
            ) {
              return item;
            }
          });
          console.log("🚀 ~ filteredNavs ~ 소변 본사 filteredNavs:", filteredNavs);
          setNavigation(filteredNavs);
        } else {
          setHideServerSelection(false);
          
          const filteredNavs = navigation.filter((item) => {
            if (item.name !== '회원권 관리2') {
              return item;
            }
          });
          console.log("🚀 ~ filteredNavs ~ 소변 관리자 filteredNavs:", filteredNavs);
          setNavigation(filteredNavs);

          // setNavigation(navigation);
        }
      }
    }

    handleOnChangeServer();
  }, []);

  const handleLogout = () => {
    console.log('CALLED LOGOUT ==> ');
    Cookies.remove('access-token');
    // localStorage.removeItem("adminInfo");
    // setAuth({});
    logout();
    navigate('/');
  };

  function handleOnClickUserMenuItem(id) {
    console.log('MENU ID => ', id);
    switch (id) {
      case 'logout':
        handleLogout();
        break;
      default:
        break;
    }
  }

  /**
   * 접속할 서버 선택하기
   */
  function handleOnChangeServer() {
    // console.log("HANDLE ON CHANGE SERVER ==>>> ");
    const savedBaseURL = localStorage.getItem('baseURL') || process.env.REACT_APP_API_URL;
    // console.log("🚀 ~ handleOnChangeServer ~ savedBaseURL:", savedBaseURL);
    setBaseURL(savedBaseURL);
  }

  return (
    <>
      <div className="flex h-screen flex-col overflow-hidden bg-white">
        <Dialog
          as="div"
          open={sidebarOpen}
          className="relative z-40 lg:hidden"
          onClose={setSidebarOpen}
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
          />

          <div className="fixed inset-0 flex">
            <DialogPanel
              transition
              className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
            >
              <TransitionChild>
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                  <button type="button" className="-m-2.5 p-2.5" onClick={() => setSidebarOpen(false)}>
                    <span className="sr-only">닫기</span>
                    <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </TransitionChild>
              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-4 ring-1 ring-white/10">
                <div className="flex h-8 shrink-0 items-center">
                  <Link to={'/ad/dashboard'}>
                    <img className="h-8 w-auto" src={Logo} alt="S휴먼헬스케어" />
                  </Link>
                </div>
                <nav className="flex flex-1 flex-col">
                  <ul className="flex flex-1 flex-col gap-y-7">
                    <li>
                      <ul className="-mx-2 space-y-1">
                        {navigation.map((item) => (
                          <li key={item.name}>
                            {auth && auth.admin_level_cd === '0009' && item.href === '' && (
                              <div className="text-xs font-bold leading-6 my-3 text-gray-200">{item.name}</div>
                            )}
                            {item.href !== '' && (
                              <Link
                                to={item.href}
                                className={classNames(
                                  location.pathname === item.href
                                    ? 'bg-gray-800 text-white'
                                    : 'text-gray-400 hover:text-white hover:bg-gray-800',
                                  'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                                )}
                              >
                                <item.icon className="h-6 w-6 shrink-0" aria-hidden="true" />
                                {item.name}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </div>
        </Dialog>

        {/* Static sidebar for desktop */}
        {/*
          플로팅 사이드바: 고정 컨테이너(w-72)에 패딩을 줘 카드를 안쪽으로 들이고
          라운드+그림자로 띄운다. 여백이 사이드바 자기 폭에서 나오므로
          본문의 lg:pl-72 는 그대로 둔다(레이아웃 폭 계산 불변).
          상단바(h-16)를 덮고 올라앉는다: top-0 에서 시작하되 pt-4 로 화면 위쪽 여백은 남기고,
          z-50 으로 상단바(z-40)보다 위에 그린다. 상단바 콘텐츠는 lg:pl-64 로 밀어
          사이드바 밑에 가려지지 않게 한다.
          접힘: 자기 폭만큼 왼쪽으로 밀어(-translate-x-full) 화면 밖으로 보낸다.
          display 를 끄지 않는 이유는 트랜지션이 재생돼야 하고, lg:hidden 과 lg:flex 가
          같은 미디어쿼리에서 충돌해 순서에 의존하게 되기 때문.
        */}
        <div
          className={classNames(
            'hidden transition-transform duration-300 ease-[cubic-bezier(.4,0,.2,1)] lg:fixed lg:bottom-0 lg:left-0 lg:top-0 lg:z-50 lg:flex lg:w-72 lg:flex-col lg:pr-4 lg:pt-4',
            sidebarCollapsed ? 'lg:-translate-x-full' : 'lg:translate-x-0'
          )}
        >
          {/*
            접기 버튼은 카드 안이 아니라 fixed 컨테이너 기준 absolute 로 둔다.
            카드가 overflow-y-auto 라 안에 넣으면 목록이 길 때 같이 스크롤돼 사라진다.
            top/right-7 = 컨테이너 패딩(16px) + 카드 안쪽 12px → 카드 우상단 모서리.
          */}
          <button
            type="button"
            onClick={() => setSidebarCollapsed(true)}
            aria-label="사이드바 접기"
            aria-expanded={true}
            className="motion-press absolute right-7 top-7 z-10 inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-400 hover:bg-gray-800 hover:text-white"
          >
            <TbLayoutSidebarLeftCollapse className="h-5 w-5" aria-hidden="true" />
          </button>
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="shadow-float flex grow flex-col gap-y-5 overflow-y-auto rounded-r-2xl bg-gray-900 px-6 py-6 ring-1 ring-white/10">
            <label className="flex shrink-0 items-center justify-center text-lg font-bold text-gray-100">
              S휴먼헬스케어 {isUrinalysis() ? '소변검사' : '활성산소'}
            </label>
            <div className="flex h-24 mt-6 shrink-0 items-center justify-center cursor-pointer">
              <a href='/ad/dashboard'>
                <img className="h-32 w-auto" src={Logo} alt="S휴먼헬스케어" />
              </a>
            </div>
            <nav className="flex flex-1 flex-col mt-5">
              <ul className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        {auth && auth.admin_level_cd === '0009' && item.href === '' && (
                          <div className="text-xs font-bold leading-6 my-3 text-gray-200">{item.name}</div>
                        )}
                        {item.href !== '' && (
                          <Link
                            to={item.href}
                            className={classNames(
                              location.pathname === item.href
                                ? 'bg-gray-800 text-white'
                                : 'text-gray-400 hover:text-white hover:font-bold hover:text-base hover:bg-gray-800',
                              'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-normal'
                            )}
                          >
                            <item.icon className="h-6 w-6 shrink-0" aria-hidden="true" />
                            {item.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
            <VersionComponent />
          </div>
        </div>

        {/* 상단바: 배경/보더는 화면 전체 폭. 사이드바가 위를 덮으므로 z 는 그보다 낮게. */}
        <div className="z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-300 bg-zinc-100 px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <button type="button" className="-m-2.5 p-2.5 text-gray-700 lg:hidden" onClick={() => setSidebarOpen(true)}>
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>

            {/* 접혔을 때만 노출되는 펼치기 버튼 — 사라진 사이드바 자리(좌상단)에 원형으로 남는다 */}
            {sidebarCollapsed && (
              <button
                type="button"
                onClick={() => setSidebarCollapsed(false)}
                aria-label="사이드바 펼치기"
                aria-expanded={false}
                className="motion-press hidden h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-gray-600 shadow-sm ring-1 ring-gray-300 hover:bg-gray-50 lg:inline-flex"
              >
                <TbLayoutSidebarLeftExpand className="h-5 w-5" aria-hidden="true" />
              </button>
            )}

            {/* 펼침: lg:pl-64 = px-8(32px) + 256px → 사이드바 폭(288px) 바로 뒤에서 시작 */}
            <div
              className={classNames(
                'flex flex-1 gap-x-4 transition-[padding] duration-300 ease-[cubic-bezier(.4,0,.2,1)] lg:gap-x-6',
                sidebarCollapsed ? 'lg:pl-0' : 'lg:pl-64'
              )}
            >
              <div className="relative flex flex-1 items-center">
                <span className="text-base font-semibold text-gray-700">
                  현재 접속 서버: <span className="font-bold text-indigo-600">{env.key}</span>
                </span>
              </div>
              <div className="flex items-center gap-x-4 lg:gap-x-6  px-3 py-3">
                {/* Profile menu dropdown */}
                <Menu as="div" className="relative ">
                  <MenuButton className="-m-1.5 flex items-center p-1.5 focus:outline-none outline-none border-none">
                    <span className="inline-block h-10 w-10 overflow-hidden rounded-full bg-gray-100 border border-gray-300">
                      <svg className="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </span>
                    <span className="hidden lg:flex lg:items-center">
                      <span className="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">
                        {auth.admin_name}
                      </span>
                      <ChevronDownIcon className="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                    </span>
                  </MenuButton>
                  <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
                  >
                    {userNavigation.map((item) => (
                      <MenuItem key={item.name}>
                        <span
                          onClick={() => handleOnClickUserMenuItem(item.id)}
                          className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 cursor-pointer"
                        >
                          {item.name}
                        </span>
                      </MenuItem>
                    ))}
                  </MenuItems>
                </Menu>
              </div>
            </div>
          </div>
        {/* 상단바 아래 영역 — 사이드바는 fixed 라 폭을 pl-72 로만 비워둔다(접히면 0). */}
        <div
          className={classNames(
            'flex min-h-0 flex-1 flex-col transition-[padding] duration-300 ease-[cubic-bezier(.4,0,.2,1)]',
            sidebarCollapsed ? 'lg:pl-0' : 'lg:pl-72'
          )}
        >
          <main className="min-h-0 flex-1 overflow-y-auto py-4">
            <div className="h-full px-4 sm:px-5 lg:px-6">{children}</div>
          </main>
        </div>
      </div>
    </>
  );
}
